export const buildMailToHref = (email: string): string => `mailto:${email}`
